// Centred auth column shared by /login and /callback: the logo above one card on
// the tinted ground. Structure: shadcn-ui/ui apps/v4/registry/new-york-v4/blocks/login-03/page.tsx
// — MIT (min-h-svh centred column, brand mark above the card). Only the column is
// centred; text inside stays left-aligned (ui/DESIGN.md §2).
//
// No theme control here (owner, 2026-09-17): the signed-out screens carry none.
// They still render in the reader's theme — the init script in index.html sets
// <html data-theme> before the first paint, and ThemeProvider keeps following
// the OS — there is simply nothing to press until after signing in.

import type { ReactNode } from "react";
import { Card, Logo } from "@/ui";

export function AuthLayout({
  children,
  aside,
}: {
  /** Card body (CardHeader with the page h1, then CardContent). */
  children: ReactNode;
  /** Optional small print under the card. */
  aside?: ReactNode;
}) {
  return (
    <div
      data-slot="auth-screen"
      className="flex min-h-dvh flex-col items-center justify-center bg-surface-1 px-4 py-10 sm:px-6"
    >
      <main className="flex w-full max-w-[26rem] flex-col gap-6">
        <Logo />
        <Card className="gap-6">{children}</Card>
        {aside && <div className="text-sm text-fg-2">{aside}</div>}
      </main>
    </div>
  );
}
